import type { EnrollmentByCourseDto, GetEnrollmentsByCourseParams, PaginatedResponseDto } from "@repo/types";
import { useQuery } from "@tanstack/react-query";
import { getCourseEnrollments } from "../api/courseApi";

/**
 * 강의별 수강 목록 조회 hook
 *
 * @param courseId - 강의 ID
 * @param params - 페이지네이션 파라미터
 * @returns React Query 결과
 */
export const useCourseEnrollments = (
  courseId: number,
  params: GetEnrollmentsByCourseParams
) => {
  return useQuery<PaginatedResponseDto<EnrollmentByCourseDto>>({
    queryKey: ["course", courseId, "enrollments", params],
    queryFn: () => getCourseEnrollments(courseId, params),
    enabled: !!courseId,
  });
};
